export function validateString(param: string): boolean {
  return !(undefined === param || null === param || "" === param);
}

export function removeUnderscores(param: string): string {
  return param.replace("_", "-");
}

export function normalizeDocumentName(documentName: string) {
  return documentName + (documentName.endsWith(".docx") ? "" : ".docx");
}
